import { ArquivoWebDTO, BaseFiltroPagDTO, ResultPagDTO } from "@/interfaces/base-dto";
import { NotificacaoFiltroDTO, NotificacaoParmDTO } from "@/interfaces/notification";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function uploadNotificationImage(file: File): Observable<ArquivoWebDTO> {
  return from(apiClient.postMultipartFormData(`${ENDPOINTS.NOTIFICATION_IMAGE}`, { file: file })).pipe(map((r: any) => r.data));
}

export function saveNotification(notification: NotificacaoParmDTO): Observable<number> {
  if (notification.id) {
    return from(apiClient.put(`${ENDPOINTS.NOTIFICATION}`, notification)).pipe(map((r: any) => r.data));
  }
  return from(apiClient.post(`${ENDPOINTS.NOTIFICATION}`, notification)).pipe(map((r: any) => r.data));
}

export function findNotificationsByFilters(filters: NotificacaoFiltroDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION}`, filters)).pipe(map((r: any) => r.data));
}

export function findNotificationById(id: Number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION}/${id}`)).pipe(map((r: any) => r.data));
}

export function findNotificationProfiles(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_PROFILE}`)).pipe(map((r: any) => r.data));
}

export function findNotificationBusinessUnit(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_BUSINESS_UNIT}`)).pipe(map((r: any) => r.data));
}

export function findNotificationTypes(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_TYPES}`)).pipe(map((r: any) => r.data));
}

export function findNotificationLoginsNotified(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_LOGINS_NOTIFIED}`)).pipe(map((r: any) => r.data));
}

export function findNotificationLoginsCreator(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_LOGINS_CREATOR}`)).pipe(map((r: any) => r.data));
}

export function findNotificationLogins(idsBusinessUnits: number[]): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_LOGINS}`, {idsEmpresas: idsBusinessUnits})).pipe(map((r: any) => r.data));
}

export function findNotificationsReading(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_READING}`)).pipe(map((r: any) => r.data));
}

export function findNotificationsReadingPage(filters: BaseFiltroPagDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_READING_PAGE}`, filters)).pipe(map((r: any) => r.data));
}

export function getNotificationReading(id): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_READING}/${id}`)).pipe(map((r: any) => r.data));
}

export function getNotificationPreview(id): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.NOTIFICATION_READING}/${id}/previsualizar`)).pipe(map((r: any) => r.data));
}